import { render, staticRenderFns } from "./BatchSearch.vue?vue&type=template&id=23501540&scoped=true"
import script from "./BatchSearch.vue?vue&type=script&lang=js"
export * from "./BatchSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23501540",
  null
  
)

export default component.exports